<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const FOREST_PURPOSE = 'get_forest_purpose.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'forestPurpose',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: null,
			disabled: false
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_forest_purpose`, {index: this.line_count, value: this.selected})
			}
		},
		created: function () {
			if(this.$parent.data_location.forest_purpose.length)
			{	
				this.options = this.$parent.data_location.forest_purpose
				this.selected = this.$props.id ? this.$props.id : this.$parent.data_location.forest_purpose[0].id

				EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
			} else {
				EventBus.$on('fetch_protective_cat_complete', () => {
					this.options = this.$parent.data_location.forest_purpose
					this.selected = this.$props.id ? this.$props.id : this.$parent.data_location.forest_purpose[0].id

					EventBus.$off('fetch_protective_cat_complete')
				})				
			}

			/*
			fetch(DB + FOREST_PURPOSE, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.$props.id ? this.$props.id : data[0].id
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err)) */
		}
	}
</script>


// WEBPACK FOOTER //
// forestPurpose.vue?d4a510ec